import { useState } from 'react';
import { playerMuted, setMuted, soundAllowed } from '../audio';
import { comfort, storeComfort, type Comfort, type FlashLevel, type MotionLevel } from '../comfort';

/**
 * How hard the replay hits: shake, flashes, whether to watch it at all, and
 * sound; and how much the console itself moves. Here before the first replay
 * and in the game's own menu during one (ethical audit E06). Every choice
 * keeps every decision and every result.
 */
export function ComfortSetting() {
  const [c, setC] = useState<Comfort>(comfort);
  const [muted, setMute] = useState(playerMuted);
  const put = (next: Comfort) => { setC(next); storeComfort(next); };
  return <>
    <div className="section-label">Comfort</div>
    <label className="row">
      <span className="grow sub">Replays</span>
      <select id="comfort-replays" value={c.replays} onChange={(e) => put({ ...c, replays: e.target.value as Comfort['replays'] })}>
        <option value="play">Watch each exchange</option>
        <option value="report">Written report only</option>
      </select>
    </label>
    <label className="row">
      <span className="grow sub">Screen flashes</span>
      <select id="comfort-flashes" value={c.flashes} onChange={(e) => put({ ...c, flashes: e.target.value as FlashLevel })}>
        <option value="full">Full</option>
        <option value="reduced">Reduced: a faint glow, no flicker</option>
        <option value="off">Off</option>
      </select>
    </label>
    <label className="row">
      <span className="grow sub">Console motion</span>
      <select id="comfort-motion" value={c.motion} onChange={(e) => put({ ...c, motion: e.target.value as MotionLevel })}>
        <option value="full">Full: static, interference, trays</option>
        <option value="reduced">Reduced: short fades only</option>
        <option value="off">Off: every change at once</option>
      </select>
    </label>
    <label className="row">
      <span className="grow sub">Camera shake</span>
      <input id="comfort-shake" type="checkbox" checked={c.shake} onChange={(e) => put({ ...c, shake: e.target.checked })} />
    </label>
    {soundAllowed()
      ? <label className="row">
        <span className="grow sub">Sound</span>
        <input id="comfort-sound" type="checkbox" checked={!muted} onChange={(e) => { setMuted(!e.target.checked); setMute(!e.target.checked); }} />
      </label>
      // The owner has the game's sound off for now (D37): nothing to choose.
      : <p className="row sub" data-testid="comfort-sound-off"><span className="grow">Sound</span><span>Off for now</span></p>}
    <p className="sub" style={{ fontSize: 'var(--fs-sm)', marginTop: 6 }}>
      Starts from your device's reduced-motion setting. A written report keeps every result of the exchange.
    </p>
  </>;
}
